module.exports = {"validation":{"required":"Este valor es obligatorio","email":"Dirección de correo electrónico no válida"}}